var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M33.3346 30H10.668V14H21.3213H33.3346V30Z","stroke":"black","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M33.3346 14V15.106L24.2113 21.3274C23.5743 21.7633 22.7899 22 21.9824 22C21.1749 22 20.3905 21.7633 19.7535 21.3274L10.668 15.106V14H33.3346Z","stroke":"black","strokeWidth":"3","strokeLinejoin":"round","key":2})]);
}

Mail.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
